import { render, staticRenderFns } from "./WithdrawalRecord.vue?vue&type=template&id=1e0a1213&scoped=true&"
import script from "./WithdrawalRecord.vue?vue&type=script&lang=js&"
export * from "./WithdrawalRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0a1213",
  null
  
)

export default component.exports